import { GenerationModelDetails } from '../dicom/dicomBase';
import { DicomPlan } from '../dicom/dicomPlan';
import { DoseMatrix } from './doseMatrix';
import { StructureSet } from './structureset';

export class Plan {
    public doseMatrix: DoseMatrix | null = null;

    public structureSet: StructureSet | null = null;

    constructor(
        private readonly _dicomPlan: DicomPlan,
        public readonly sopInstanceUid: string,
        public readonly label: string,
        public readonly referencedStructureSetUid: string
    ) {}

    public get dicom(): DicomPlan | null {
        return this._dicomPlan;
    }

    public get generationModel(): GenerationModelDetails | undefined {
        return this._dicomPlan.generationModel;
    }

    public get isNew(): boolean {
        return this._dicomPlan.isNew;
    }

    public setExported(): void {
        this._dicomPlan.setExported();
    }
}
